<div class="layout-footer">
    <div class="footer-logo-container">
        <!-- <img id="footer-logo" [src]="'assets/layout/images/logo-'+ (app.colorScheme === 'light' ? 'dark' : 'white') + '.svg'" alt="diamond-layout"/> -->
        <span class="app-name">{{organizationName}}</span>
    </div>
    <span class="copyright">&#169; edent.uz - 2025</span>
</div>
